import {
	DialogContentProps,
	DialogActions as MuiDialogActions,
	DialogContent as MuiDialogContent,
	DialogTitle as MuiDialogTitle,
	StyleRules,
	type Theme,
	createStyles,
	withStyles,
} from "@material-ui/core";
import Dialog from "@material-ui/core/Dialog";
import IconButton from "@material-ui/core/IconButton";
import Typography from "@material-ui/core/Typography";
import { type WithStyles } from "@material-ui/core/styles";
import CloseIcon from "@material-ui/icons/Close";
import React, { ReactNode } from "react";

const styles: (theme: Theme) => StyleRules = (theme: Theme) =>
	createStyles({
		root: {
			margin: 0,
			padding: theme.spacing(2),
		},
		closeButton: {
			position: "absolute",
			right: theme.spacing(1),
			top: theme.spacing(1),
			color: theme.palette.grey[500],
		},
	});
export interface DialogTitleProps extends WithStyles<typeof styles> {
	id: string;
	children: React.ReactNode;
	onClose: () => void;
}

const DialogTitle = withStyles(styles)((props: DialogTitleProps) => {
	const { children, classes, onClose, ...other } = props;
	return (
		<MuiDialogTitle
			disableTypography
			style={{
				display: "flex",
				flexWrap: "nowrap",
				justifyContent: "space-between",
				alignItems: "baseline",
			}}
			{...other}
		>
			<Typography variant="h6">{children}</Typography>
			{onClose ? (
				<IconButton
					aria-label="close"
					className={classes.closeButton}
					onClick={onClose}
				>
					<CloseIcon />
				</IconButton>
			) : (
				<></>
			)}
		</MuiDialogTitle>
	);
});

interface CustomDialogContentProps extends Partial<DialogContentProps> {
	children: ReactNode;
}

const DialogContent = withStyles((theme: Theme) => ({
	root: {
		padding: theme.spacing(2),
		minWidth: 600,
		overflow: "hidden",
	},
}))(MuiDialogContent as any) as typeof MuiDialogContent;

const DialogActions = withStyles((theme: Theme) => ({
	root: {
		margin: 0,
		padding: theme.spacing(1),
	},
}))(MuiDialogActions as any) as typeof MuiDialogActions;

interface MESFModalProps {
	handleClose: (shouldUpdate?: boolean) => void;
	open: boolean;
	id?: string;
	maxWidth?: "xs" | "sm" | "md" | "lg" | "xl" | false;
	children: ReactNode;
	title?: string;
}

function Modal({
	children,
	title,
	handleClose,
	open,
	id = "mesf-modal",
	maxWidth = "lg",
}: MESFModalProps) {
	return (
		<Dialog
			onClose={() => handleClose()}
			aria-labelledby={id}
			open={open}
			maxWidth={maxWidth}
			style={{ minWidth: 320 }}
		>
			<DialogTitle id={id} onClose={() => handleClose()}>
				{title}
			</DialogTitle>
			{children}
		</Dialog>
	);
}

export const MesfModal = Object.assign(Modal, {
	Content: DialogContent,
	Actions: DialogActions,
});

export default MesfModal;
